'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.GridWidgetTypes = void 0;
(function (GridWidgetTypes) {
    GridWidgetTypes["TEXT_GRID"] = "TEXT_GRID";
    GridWidgetTypes["INLINE_TEXT"] = "INLINE_TEXT";
    GridWidgetTypes["IMAGE_INFO_LAYOUT_CARD"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard";
    GridWidgetTypes["RESTAURANT_CARD"] = "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle";
})(exports.GridWidgetTypes || (exports.GridWidgetTypes = {}));
//# sourceMappingURL=type.js.map
